export default __webpack_public_path__ + "media/images/images_v2/iui/selection-26f093849c3492d0bcce2739f820be1b.png";